// Event types — mirror of backend/categories.py EVENT_TYPES (SSOT)
export const EVENT_TYPES = [
  { value: "casting",     label: "Casting",            short: "Casting",     accent: "#C68E59", desc: "Sélections mannequins & modèles" },
  { value: "shooting",    label: "Shooting photo",     short: "Shooting",    accent: "#8B5A2B", desc: "Séances photo & éditoriaux" },
  { value: "defile",      label: "Défilé / Runway",    short: "Défilé",      accent: "#1A1A1A", desc: "Shows, runway & présentations" },
  { value: "showroom",    label: "Showroom & Presse",  short: "Showroom",    accent: "#A3483F", desc: "Présentations collections" },
  { value: "masterclass", label: "Masterclass",        short: "Masterclass", accent: "#2E5E4E", desc: "Ateliers & formations" },
  { value: "networking",  label: "Rencontre pro",      short: "Networking",  accent: "#3B5BDB", desc: "Rencontres entre créateurs & talents" },
  { value: "soiree",      label: "Soirée & Lancement", short: "Soirée",      accent: "#6E4B2A", desc: "Lancements & soirées privées" },
];
const LEGACY_EVENT = { fashion_event: "defile", vip: "soiree" };
export function normalizeEventType(v) { return LEGACY_EVENT[v] || v; }
export function eventTypeMeta(v) {
  const n = normalizeEventType(v);
  return EVENT_TYPES.find((e) => e.value === n) || { value: n, label: n || "Événement", short: n || "Événement", accent: "#C68E59" };
}
export function labelEventType(v) { return eventTypeMeta(v).label; }


/**
 * Helencia — Role & category SSOT.
 *
 * Two roles:
 *   • "talent"   : incarnent devant l'objectif (mannequin, modèle, acteur, danseur, performer, influenceur, artiste…)
 *   • "creator"  : créent / organisent / produisent (photographe, styliste, MUA, DA, marque, agence…)
 *
 * Both lists cover the 18 industry categories requested by the product team
 * (2026-10-01), with extras to stay future-proof. "creator" is the canonical
 * role since the 2026-02 migration (legacy "professional" still accepted on
 * read for back-compat).
 */

/** TALENT categories — profiles that appear in front of the lens / on stage. */
export const TALENT_TYPES = [
  // Mannequins & modèles (specialised)
  { value: "mannequin",            label: "Mannequin" },
  { value: "modele",               label: "Modèle" },
  { value: "modele_editorial",     label: "Modèle éditorial" },
  { value: "modele_commercial",    label: "Modèle commercial" },
  { value: "modele_fitness",       label: "Modèle fitness" },
  { value: "modele_grande_taille", label: "Modèle grande taille" },
  { value: "modele_enfant",        label: "Modèle enfant" },
  { value: "modele_senior",        label: "Modèle senior" },
  // Performance & creative talent
  { value: "actrice",              label: "Acteur / Actrice" },
  { value: "danseur",              label: "Danseur / Danseuse" },
  { value: "performer",            label: "Performer" },
  // Content & reach
  { value: "influenceur",          label: "Influenceur / Influenceuse" },
  { value: "createur_contenu",     label: "Créateur de contenu" },
  // Open-ended
  { value: "artiste",              label: "Artiste" },
];

/** CREATOR categories — profiles that produce / organise / build. */
export const CREATOR_TYPES = [
  // Image makers
  { value: "photographer",     label: "Photographe" },
  { value: "videographer",     label: "Vidéaste" },
  { value: "photo_retoucher",  label: "Retoucheur photo" },
  // Styling & beauty
  { value: "stylist",          label: "Styliste" },
  { value: "mua",              label: "Maquilleur / Maquilleuse" },
  { value: "hair",             label: "Coiffeur / Coiffeuse" },
  // Direction & design
  { value: "art_director",     label: "Directeur artistique" },
  { value: "fashion_designer", label: "Designer de mode" },
  { value: "producer",         label: "Producteur" },
  // Organisations
  { value: "brand",            label: "Marque indépendante" },
  { value: "studio",           label: "Studio" },
  { value: "agency",           label: "Agence créative" },
  { value: "model_agency",     label: "Agence de mannequins" },
  { value: "independent",      label: "Indépendant" },
];

/** Backwards-compat: old talent_type values that should be read as creator. */
export const LEGACY_TALENT_TO_CREATOR = {
  mua: "mua",
  coiffeur: "hair",
};

/** Map any stored talent_type to a clean label — resilient to legacy values. */
export function labelTalentType(v) {
  if (!v) return "";
  const found = TALENT_TYPES.find((t) => t.value === v);
  if (found) return found.label;
  if (v === "autre") return "Autre";
  return v;
}

/** Backwards-compat for legacy pro_type values. */
const LEGACY_PRO_TYPE_LABELS = {
  beauty: "Beauté",
  project: "Porteur de projet",
  agence_mode: "Agence de mode",
  marque_independante: "Marque indépendante",
  studio_creatif: "Studio créatif",
  professionnel: "Indépendant",
};

export function labelCreatorType(v) {
  if (!v) return "";
  const found = CREATOR_TYPES.find((t) => t.value === v);
  if (found) return found.label;
  if (LEGACY_PRO_TYPE_LABELS[v]) return LEGACY_PRO_TYPE_LABELS[v];
  return v;
}

/** Role wording helpers. */
export const ROLE_LABEL = {
  talent: "Talent",
  creator: "Créateur",
  professional: "Créateur",
  admin: "Admin",
};

export const ROLE_LABEL_PLURAL = {
  talent: "Talents",
  creator: "Créateurs",
  professional: "Créateurs",
};
